import { render } from "./qjcx.vue?vue&type=template&id=507f1871"
import script from "./qjcx.vue?vue&type=script&lang=js"
export * from "./qjcx.vue?vue&type=script&lang=js"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__